import { createSelector } from '@reduxjs/toolkit';

import type { SliceStateFromReducer } from 'shared/types';

import type { vitrinsFiltersSlice } from 'entities/vitrinsFilters';

export type TVitrinsFiltersState = SliceStateFromReducer<typeof vitrinsFiltersSlice>;
export const selectVitrinsFilters = (state: TVitrinsFiltersState) => state.vitrinsFilters;

export const selectActiveVitrinsFilters = createSelector(selectVitrinsFilters, (filters) =>
  filters
    .filter((f) => f.selectedValue)
    .reduce<Record<string, string>>((acc, f) => {
      acc[f.alias] = f.selectedValue!;
      return acc;
    }, {}),
);

export const selectAllVitrinsFilterFields = createSelector(selectVitrinsFilters, (filters) =>
  filters.flatMap((filter) =>
    (filter.fields ?? []).map((field) => ({
      name: field.name,
      value: field.value,
      selected: filter.selectedValue === field.value,
      alias: filter.alias,
    })),
  ),
);
